import { getUser } from '@loggi/authentication-lib';

export const hasCurrentUserUseCase = () => getUser().then(session => !!session);

export default { hasCurrentUserUseCase };
